module.exports = __webpack_public_path__ + "static/img/circle-3.baa27a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/circle-3.png
// module id = 26UE
// module chunks = 0